import { DOMRouteHandler } from './DOMRouteHandler';

export class TemplateProductDna extends DOMRouteHandler {}
